module.exports = __webpack_public_path__ + "img/circularStrategy21.1ff7f24d.png";